module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="zmags-input-control slider-control-container">\n    <label class="slider-control" ';
 if (unit) { ;
__p += ' data-unit="' +
__e( unit ) +
'" style="margin-right: 20px;"';
 } ;
__p += '>\n        ';
 if (staticVal) { ;
__p += '\n        <div class="static-value">\n            <div class="value">' +
__e( staticVal ) +
'</div>\n            <div class="value-indicator"></div>\n        </div>\n        ';
 } ;
__p += '\n\n        <div class="slider-background-color"></div>\n        <div class="slider-left-color"></div>\n        <div class="slider-value"></div>\n        <input class="slider" type="range" min="' +
__e( minVal ) +
'" max="' +
__e( maxVal ) +
'" step="' +
__e( step ) +
'">\n\n        ';
 if (minLabel && maxLabel) { ;
__p += '\n        <span class="min-label pull-left">' +
__e( minLabel ) +
'</span>\n        <span class="max-label pull-right">' +
__e( maxLabel ) +
'</span>\n        ';
 } ;
__p += '\n    </label>\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/services/rangeInput/RangeInput.tpl
// module id = 1743
// module chunks = 0